import { cloneElement, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CustomModalProps } from './interfaces';

export type ModalSizeType = 'lg' | undefined;

const CustomModal = ({ show, title, type, children, onSubmit, onHide }: CustomModalProps) => {
  const [modalSize, setModalSize] = useState<ModalSizeType>(undefined);

  const handleHide = () => {
    onHide();
    setModalSize(undefined);
  };

  const handleClick = () => {
    onSubmit();
  };

  const changeSize = (size: ModalSizeType) => {
    setModalSize(size);
  };

  const getTitleAction = () => {
    if (type === 'CREATE') return 'Guardar';
    else if (type === 'EDIT') return 'Editar';
    else return 'Eliminar';
  };

  const buttonText = getTitleAction();

  return (
    <Modal size={modalSize} show={show} onHide={handleHide} backdrop="static">
      <Modal.Header>{`${getTitleAction()} ${title}`}</Modal.Header>
      <Modal.Body>{cloneElement(children, { changeSize })}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={handleClick}>
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
